<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  height: 100%;
  line-height: 1.8;
  font-size: 28px;
  background-color: #F1F1F1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue